import * as React from "react";
import { makeUseContext } from "../utils.js";
const EventsContext = React.createContext(null);
export const useEvents = makeUseContext("useEvents", "EventsContext", EventsContext);
export const EventsProvider = ({ children }) => {
    const [subscriptions] = React.useState({});
    React.useEffect(() => () => {
        Object.keys(subscriptions).forEach((key) => delete subscriptions[key]);
    }, [subscriptions]);
    const context = React.useMemo(() => {
        const unsubscribe = (topic, callback) => {
            if (subscriptions[topic]) {
                subscriptions[topic] = subscriptions[topic].filter((cb) => cb !== callback);
            }
        };
        const subscribe = (topic, callback) => {
            if (!subscriptions[topic]) {
                subscriptions[topic] = [];
            }
            subscriptions[topic].push(callback);
            return () => unsubscribe(topic, callback);
        };
        const publish = (topic, event) => {
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : _a.forEach((callback) => callback(event));
        };
        return { publish, subscribe, unsubscribe };
    }, [subscriptions]);
    return React.createElement(EventsContext.Provider, { value: context }, children);
};
